import styled from 'styled-components';
import colors from '@theme/colors';

export const Container = styled.div`
  background-color: ${colors.LIGHT_BLUE};
  padding: 8px;
  display: flex;
  flex-direction: column;
`;

export const Form = styled.form`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const Content = styled.section`
  flex: 1;
  display: flex;
  flex-direction: column;
  margin-left: 10px;
`;

export const Footer = styled.footer`
  display: flex;
  justify-content: flex-end;

  > * {
    margin-right: 8px;

    &:last-child {
      margin-right: 0px;
    }
  }
`;



// WEBPACK FOOTER //
// ./components/atoms/AdminForm.js